import { render, staticRenderFns } from "./plan_addoredit.vue?vue&type=template&id=5d851232&"
import script from "./plan_addoredit.vue?vue&type=script&lang=js&"
export * from "./plan_addoredit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports